import { IDENTITY_BASE_URL, IDENTITY_TEST_URL } from "shared/config/constants";

export function getIdentityBaseUrl() {
  const mode = (localStorage.getItem("apiMode") || "TEST").toUpperCase();
  return mode === "TEST" ? IDENTITY_TEST_URL : IDENTITY_BASE_URL;
}
